import { autoserializeAs } from 'cerialize';
import { DocumentTypeStatus } from './document-type-status';
import { TransitProgramVehicleStatus } from './transit-program-vehicle-status';
import { Vehicle } from './vehicle';

export class VehicleStatus {
  @autoserializeAs(Vehicle)
  vehicle: Vehicle;

  @autoserializeAs(DocumentTypeStatus)
  documentTypeStatuses: Array<DocumentTypeStatus>;

  @autoserializeAs(TransitProgramVehicleStatus)
  transitProgramVehicleStatuses: Array<TransitProgramVehicleStatus>;
}
